// src/components/note/note.component.js
import React, { Component } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
//import ComingSoonm from "../menu/comingsoonm.component";
import styled, { createGlobalStyle } from "styled-components";
import ReactGA from "react-ga4";

const GlobalStyle = createGlobalStyle`
  body {
    padding: 0;
    margin: 0;
    align-items: center;
    background: linear-gradient(45deg, #1d9bf0, #ff0080, #4c00ff, #ff7b00);
    background-size: 400% 400%;
    background-attachment: fixed;
    animation: gradientRotate 15s ease infinite;
  }
  
  @keyframes gradientRotate {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
  .p-note {
    word-break: break-word;
    overflow-wrap: break-word;
  }
`;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(45deg, #1d9bf0, #ff0080, #4c00ff, #ff7b00);
  background-size: 400% 400%;
  background-attachment: fixed;
  animation: gradientRotate 15s ease infinite;

  @keyframes gradientRotate {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
  flex-wrap: wrap;
  padding-top: 10px;
  width: 100%;
  max-width: 800px;
`;

const NoteCard = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  padding: 20px;
  margin: 20px;
  width: 90%;
  max-width: 600px;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const NoteTitle = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center;
`;

const NoteDescription = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 20px;
`;

const MapContainer = styled.div`
  width: 100%;
  height: 200px;
  background-color: #f0f0f0;
  border-radius: 5px;
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
`;

const JoinButton = styled.button`
  background-color: #1d9bf0;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  margin-top: 10px;

  &:hover {
    background-color: #0d8bd0;
  }
`;

class Note extends Component {
  constructor(props) {
    super(props);

    // Get note ID from URL params
    const noteId = this.props.match.params.id;

    this.state = {
      note: {
        id: noteId || "default",
        title: "Fitness Note",
        description:
          "Join our fitness note to connect with like-minded people and achieve your goals together.",
        imageUrl:
          //"https://www.bealyo.com/images/challenges/fitness-challenge.jpg",
          "https://www.bealyo.com/images/prebealyoshare.png",
        createdDate: "2025-01-01",
        participants: 1245,
      },
    };
  }

  // Add this method to your Note class
  // Replace the generateStaticMapUrl method with this:
  generateStaticMapUrl = (coordinates) => {
    if (!coordinates || coordinates.length === 0) return null;

    // Get center point (first coordinate)
    const center = coordinates[0];
    const zoom = 15;

    // Use OpenStreetMap static map service (no API key required)
    return `https://staticmap.openstreetmap.de/staticmap.php?center=${center.latitude},${center.longitude}&zoom=${zoom}&size=600x200&maptype=mapnik&markers=${center.latitude},${center.longitude},red-pushpin`;
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.note.coordinates !== this.state.note.coordinates &&
      this.state.note.coordinates
    ) {
      this.initializeMap();
    }
  }

  componentDidMount() {
    const noteId = this.props.match.params.id;

    console.log("Note ID:", noteId);

    // Track page view
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });

    // Fetch challenge data from API
    // Fetch note data from API
    axios
      .post(process.env.REACT_APP_API_URL + "notes/pub/byid/", {
        note_id: noteId,
      })
      .then((response) => {
        const noteArray = response.data;
        const noteData = noteArray[0]; // Get the first note from the array
        const userData = noteData.user_data[0];

        // Parse note_value if it exists
        let noteValue = null;
        if (noteData.note_value) {
          try {
            noteValue = JSON.parse(noteData.note_value);
          } catch (e) {
            console.error("Error parsing note_value:", e);
          }
        }

        console.log("Note Data:", noteData);

        // Map API response to note state
        this.setState({
          note: {
            id: noteData._id,
            title: userData.name + "'s Activity",
            description: noteData.note_body,
            imageUrl: noteData.note_image
              ? process.env.REACT_APP_IMG_FOLDER + noteData.note_image
              : userData.img_url
              ? process.env.REACT_APP_IMG_FOLDER + userData.img_url
              : "https://www.bealyo.com/images/prebealyoshare.png",
            createdDate: new Date(noteData.created_date).toLocaleDateString(),
            author: userData.name,
            nickname: userData.nickname,
            privacy: noteData.note_privacy,
            noteValue: noteValue, // Include parsed note_value
            distance: noteValue ? noteValue.distance : null,
            duration: noteValue ? noteValue.duration : null,
            coordinates: noteValue ? noteValue.coordinates : null, // Add coordinates
          },
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching note:", error);
        this.setState({
          error: "Failed to load note details",
          loading: false,
        });
      });
  }

  initializeMap = () => {
    const { coordinates } = this.state.note;
    if (!coordinates || coordinates.length === 0 || !window.L) return;

    // Initialize map
    const map = window.L.map("trackMap").setView(
      [coordinates[0].latitude, coordinates[0].longitude],
      15
    );

    // Add OpenStreetMap tiles
    window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution: "© OpenStreetMap contributors",
    }).addTo(map);

    // Create polyline from coordinates
    const latlngs = coordinates.map((coord) => [
      coord.latitude,
      coord.longitude,
    ]);
    const polyline = window.L.polyline(latlngs, {
      color: "#1D9BF0",
      weight: 3,
    }).addTo(map);

    // Fit map to polyline bounds
    map.fitBounds(polyline.getBounds());

    // Add start and end markers
    window.L.marker([coordinates[0].latitude, coordinates[0].longitude])
      .addTo(map)
      .bindPopup("Start");

    window.L.marker([
      coordinates[coordinates.length - 1].latitude,
      coordinates[coordinates.length - 1].longitude,
    ])
      .addTo(map)
      .bindPopup("End");
  };

  handleJoinClick = (chid) => {
    ReactGA.event({
      category: "Note",
      action: "Join Note Click",
      label: this.state.note.title,
    });
    //window.location.href = "/comingsoon";
    window.location.href = "http://www.bealyo.com/note/" + chid;
  };

  render() {
    const { note } = this.state;
    const shareUrl = `https://www.bealyo.com/notes/${note.id}`;

    return (
      <PageContainer>
        <Helmet>
          <title>{note.title} | Bealyo</title>
          <meta name="description" content={note.description} />

          {/* App Links for Android */}
          <meta property="al:android:package" content="com.bealyo.bealyoapp" />
          <meta
            property="al:android:url"
            content={`bealyo-app://note/${note.id}`}
          />
          <meta property="al:android:app_name" content="Bealyo" />

          {/* iOS App Links */}
          <meta
            property="al:ios:url"
            content={`bealyo-app://note/${note.id}`}
          />
          <meta property="al:ios:app_store_id" content="YOUR_APP_STORE_ID" />
          <meta property="al:ios:app_name" content="Bealyo" />

          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content={shareUrl} />
          <meta property="og:title" content={note.title} />
          <meta property="og:description" content={note.description} />
          <meta property="og:image" content={note.imageUrl} />

          {/* Twitter */}
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content={shareUrl} />
          <meta property="twitter:title" content={note.title} />
          <meta property="twitter:description" content={note.description} />
          <meta property="twitter:image" content={note.imageUrl} />
        </Helmet>

        <GlobalStyle />
        <CenteredContainer>
          <NoteCard>
            <NoteTitle>{note.title}</NoteTitle>
            {/* Replace the map section with this to debug */}
            <div style={{ margin: "15px 0" }}>
              {/** 
              {note.coordinates && note.coordinates.length > 0 && (
                <div
                  style={{
                    margin: "15px 0",
                    padding: "15px",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "5px",
                    color: "#333",
                  }}
                >
                  <strong>Track Data:</strong>
                  <br />
                  Start: {note.coordinates[0].latitude.toFixed(6)},{" "}
                  {note.coordinates[0].longitude.toFixed(6)}
                  <br />
                  End:{" "}
                  {note.coordinates[
                    note.coordinates.length - 1
                  ].latitude.toFixed(6)}
                  ,{" "}
                  {note.coordinates[
                    note.coordinates.length - 1
                  ].longitude.toFixed(6)}
                  <br />
                  Points: {note.coordinates.length}
                </div>
              )}
*/}
              {note.coordinates && note.coordinates.length > 0 && (
                <div style={{ margin: "15px 0" }}>
                  <div
                    id="trackMap"
                    style={{
                      width: "100%",
                      height: "200px",
                      borderRadius: "5px",
                    }}
                  />
                </div>
              )}
            </div>

            {/* Add this after the map section and before the profile image */}
            {/* Show note image if it exists (from note_image field) */}
            {note.imageUrl &&
              note.imageUrl !==
                "https://www.bealyo.com/images/prebealyoshare.png" && (
                <div style={{ margin: "15px 0" }}>
                  <img
                    src={note.imageUrl}
                    alt="Note Image"
                    style={{
                      width: "100%",
                      height: "200px",
                      borderRadius: "5px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}

            {/**
            <img
              src={note.imageUrl}
              alt={note.title}
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                objectFit: "cover",
                marginBottom: "15px",
                display: "block",
                margin: "0 auto 15px auto",
              }}
            />
             */}
            <NoteDescription>{note.description}</NoteDescription>
            <p>
              By: {note.author} (@{note.nickname})
            </p>
            <p>Date: {note.createdDate}</p>
            {note.distance && (
              <p>Distance: {(note.distance * 1000).toFixed(0)}m</p>
            )}
            {note.duration && (
              <p>
                Duration: {Math.floor(note.duration / 60)}:
                {(note.duration % 60).toString().padStart(2, "0")}
              </p>
            )}
            <JoinButton onClick={() => this.handleJoinClick(note.id)}>
              View in App
            </JoinButton>
          </NoteCard>
        </CenteredContainer>
      </PageContainer>
    );
  }
}

export default Note;
